export default __webpack_public_path__ + "static/slider.tqimg-0de9def95c9b648e3bf543cac72fd4f1.png";